import { styled } from 'styled-components';

export const MedicalAlertSettingsWrapper = styled.div`
  margin-top: 1rem;
  margin-bottom: 0.75rem;
`;

export const CheckboxesWrapper = styled.div`
  margin-top: 0.5rem;
  margin-left: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const EmailSubscriptionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
`;

export const PersonalDetailsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 0.65rem;

  .ant-switch-checked {
    background-color: #63b7c3;
  }
`;
